import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import _ from 'lodash';
import { Toast } from 'primereact/toast';
import { Dialog } from "primereact/dialog";
import { InputText } from 'primereact/inputtext';
import { DataView } from 'primereact/dataview';

import { fetchConsumerHistory, updateSearchParams } from "../../../services/redux/reducers/consumerHistory/consumerHistory";
import { getBuyerInvoicesByBuyerPOIds } from '../../../services/api/buyerInvoice';
import { raiseToast } from '../../../services/redux/reducers/toast/toast';

import PurchaseOrderDesktopSkeleton from '../../../skeletons/PurchaseOrderDesktop';
import PurchaseOrderMobileSkeleton from '../../../skeletons/PurchaseOrderMobile';

import OrderItemTemplate from './components/OrderItemTemplate';

import { ThreeDots } from 'react-loader-spinner';
import { isMobile, round } from '../../../utils';




const ConsumerHistory = () => {
    const consumerOrders = useSelector(state => state.consumerHistory.consumerOrders)
    const materialDetails = useSelector(state => state.consumerHistory.materialDetails)
    const createdUserDetails = useSelector(state => state.consumerHistory.createdUserDetails)
    const isLoading = useSelector(state => state.consumerHistory.loading)
    const paginationParams = useSelector(state => state.consumerHistory.paginationParams)
    const searchParams = useSelector(state => state.consumerHistory.searchParams)
    const userDetails = useSelector(state => state.userDetails)

    const [isDialogLoading, setIsDialogLoading] = useState(false)
    const [viewProdctsDeatil, setViewProductsDetail] = useState(false)
    const [displayedPOPunchItems, setDisplayedPOPunchItems] = useState([])

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(fetchConsumerHistory({ ...paginationParams, ...searchParams, pmCompanyId: userDetails.PMCompanyDetails.pmCompanyId }))
    }, [])

    const handlePageChange = async (e) => {
        let paginatorParams = {
            paginator: true,
            pageNo: e.page + 1,
            recordsPerPage: e.rows,
            limitedPagination: true,
            getCount: false,
            pmCompanyId: userDetails.PMCompanyDetails.pmCompanyId,
            ...searchParams,
        }
        dispatch(fetchConsumerHistory(paginatorParams))
    }

    const handleProductsDetails = async (rowData) => {
        setViewProductsDetail(true)
        setIsDialogLoading(true)
        const updatedDisplayedPOPunchItems = []

        const buyerPOIds = rowData.poPunch.map(eachPOPunch => eachPOPunch.buyerPOId)
        const buyerInvoiceRes = await getBuyerInvoicesByBuyerPOIds({ buyerPOIds: buyerPOIds })

        if (buyerInvoiceRes.failure) {
            setIsDialogLoading(false)
            return dispatch(raiseToast({ severity: 'error', summary: 'Buyer Invoice', detail: buyerInvoiceRes.data.error, life: 3000 }))
        }
        setIsDialogLoading(false)

        const dispatchNoteItems = buyerInvoiceRes?.data?.dispatchNoteItems
        const dispatchNotes = buyerInvoiceRes?.data?.dispatchNotes
        const buyerInvoiceItems = buyerInvoiceRes?.data?.buyerInvoiceItems
        const buyerInvoices = buyerInvoiceRes?.data?.buyerInvoice
        const invoiceDispatchMap = buyerInvoiceRes?.data?.invoiceDispatchMap

        rowData.poPunch.map(eachPOPunch => {
            if (eachPOPunch.poPunchItems) {
                eachPOPunch.poPunchItems.map(eachPOPunchItem => {
                    if (eachPOPunchItem.buyerReqItemId) {
                        const relatedMaterialDetails = materialDetails.find(obj => obj.buyerReqItemId === eachPOPunchItem.buyerReqItemId)
                        const relatedDispatchNoteItems = dispatchNoteItems?.filter(eachDispatchNoteItem => eachDispatchNoteItem?.buyerPOItemId === eachPOPunchItem?.buyerPOItemId)
                        let relatedDispatchNotes = []
                        relatedDispatchNoteItems?.map(eachDispatchNoteItem => {
                            const relatedDispatchNote = dispatchNotes?.find(eachDispatchNote => eachDispatchNote?.dispatchNoteId === eachDispatchNoteItem?.dispatchNoteId && eachDispatchNoteItem?.statusId === 1)
                            if (relatedDispatchNote?.dispatchNoteId) {
                                relatedDispatchNotes.push(relatedDispatchNote)
                            }
                        })
                        let relatedInvoiceDispatchMap = []
                        relatedDispatchNotes?.map(eachDispatchNote => {
                            const relatedInvoiceDispatch = invoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.dispatchNoteId === eachDispatchNote?.dispatchNoteId)
                            if (relatedInvoiceDispatch?.length > 0) {
                                relatedInvoiceDispatchMap = [...relatedInvoiceDispatchMap, ...relatedInvoiceDispatch]
                            }
                        })

                        relatedInvoiceDispatchMap = relatedInvoiceDispatchMap?.filter(eachInvoiceDispatchMap => eachInvoiceDispatchMap?.statusId === 1)
                        relatedInvoiceDispatchMap = _.uniqBy(relatedInvoiceDispatchMap, "invoiceDispatchMapId")

                        let totalInvoicedQty = 0
                        relatedInvoiceDispatchMap?.map(eachInvoiceDispatchMap => {
                            const relatedBuyerInvoice = buyerInvoices?.find(eachBuyerInvoice => eachBuyerInvoice?.buyerInvoiceId === eachInvoiceDispatchMap?.buyerInvoiceId)
                            let relatedBuyerInvoiceItems = buyerInvoiceItems?.filter(eachBuyerInvoiceItem => eachBuyerInvoiceItem?.buyerInvoiceId === relatedBuyerInvoice?.buyerInvoiceId)

                            relatedBuyerInvoiceItems?.map(eachBuyerInvoiceItem => {
                                if (eachBuyerInvoiceItem.statusId === 1 && eachBuyerInvoiceItem?.buyerReqItemId === eachPOPunchItem?.buyerReqItemId) {
                                    totalInvoicedQty += parseFloat(eachBuyerInvoiceItem?.qty)
                                }
                            })
                        })
                        if (relatedMaterialDetails) {
                            const productDetails = {
                                productName: relatedMaterialDetails.companyProdName ? relatedMaterialDetails.companyProdName : relatedMaterialDetails.productName,
                                productSpecification: relatedMaterialDetails.companyProdSpec ? relatedMaterialDetails.companyProdSpec : relatedMaterialDetails.productSpecification,
                                quantity: relatedMaterialDetails.companyQtyMultiplier ? round(eachPOPunchItem.punchQty / relatedMaterialDetails.companyQtyMultiplier) : eachPOPunchItem.punchQty, //eachPOPunchItem.punchQty,
                                docNo: eachPOPunch.docNo,
                                clientPONum: eachPOPunchItem.buyerPO?.clientPONum ? eachPOPunchItem.buyerPO?.clientPONum : eachPOPunch.docNo,
                                punchQty: relatedMaterialDetails.companyQtyMultiplier ? round(eachPOPunchItem.buyerPOItem.bPOQty / relatedMaterialDetails.companyQtyMultiplier) : eachPOPunchItem.buyerPOItem.bPOQty, // eachPOPunchItem.buyerPOItem.bPOQty,
                                invoicedQty: relatedMaterialDetails.companyQtyMultiplier ? round(totalInvoicedQty / relatedMaterialDetails.companyQtyMultiplier) : totalInvoicedQty //totalInvoicedQty
                            }
                            updatedDisplayedPOPunchItems.push(productDetails)
                        }
                    }
                })
            }
        })

        setDisplayedPOPunchItems(updatedDisplayedPOPunchItems)
    }

    const orderTemplate = (row) => {
        return (
            <OrderItemTemplate
                orderItem={row}
                materialDetails={materialDetails}
                handleProductsDetails={handleProductsDetails}
                createdUserDetails={createdUserDetails}
            />
        )
    }

    const handleSearchTextChange = (event) => {
        let eventValue = event.target.value
        const updatedSearchParams = { ...searchParams, [event.target.name]: eventValue }
        dispatch(updateSearchParams(updatedSearchParams))
    }

    const handleSearch = () => {
        const updatedSearchParams = { ...searchParams }
        if (searchParams.searchText.trim() === "") {
            updatedSearchParams.searchBy = "all"
        } else {
            updatedSearchParams.searchBy = "buyerPONo"
        }
        dispatch(fetchConsumerHistory({ ...paginationParams, ...updatedSearchParams, companyId: userDetails.PMCompanyDetails.pmCompanyId, pageNo: 0 }))
    }

    if (isLoading) {
        return (
            isMobile() ? <PurchaseOrderMobileSkeleton /> : <PurchaseOrderDesktopSkeleton />
        )
    }

    return (
        <div className="order-history-layout flex flex-column invoices-header-section">
            <Toast ref={Toast} />

            <div className="flex flex-column md:flex-row md:justify-content-between" >
                <h3 className="m-2" style={{ borderBottom: "2px solid #0da487" }}>Order History</h3>

                <div className="catalogue-request-search md:w-5 p-input-icon-right">
                    <div className="flex flex-row justify-content-center align-items-center"
                        style={{ position: "absolute", width: "50px", height: "45px", right: 0, backgroundColor: "#ffa53b", borderTopRightRadius: "6px", borderBottomRightRadius: "6px", cursor: "pointer" }}
                        onClick={handleSearch}
                    >
                        <i className="pi pi-search" style={{ color: "white", fontSize: "17px", marginTop: "3px" }} />
                    </div>
                    <InputText placeholder="Enter document number" value={searchParams["searchText"]} style={{ width: "100%", height: "45px", fontSize: "16px", borderColor: "#ececec" }} name="searchText" onChange={(e) => handleSearchTextChange(e)} />
                </div>

                <div className="flex w-1">
                </div>
            </div>

            <div className='flex flex-row invoices-table-container'>
                <div className="open-po-table" style={{ order: "1", width: "100%" }}>
                    <div className=''>
                        <DataView
                            value={consumerOrders}
                            totalRecords={paginationParams.totalRecords}
                            itemTemplate={orderTemplate}
                            paginator
                            paginatorTemplate="RowsPerPageDropdown FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport"
                            currentPageReportTemplate=""  // {first} to {last} of {totalRecords}
                            rows={paginationParams.recordsPerPage}
                            loading={isLoading}
                            onPage={e => handlePageChange(e)}
                            page={paginationParams.pageNo}
                            first={paginationParams.pageNo * paginationParams.recordsPerPage}
                            lazy
                        />
                    </div>
                </div>
            </div>

            <Dialog visible={viewProdctsDeatil} style={{ width: '75vw', height: '75vh', backgroundColor: '#f8f8f8' }} onHide={() => setViewProductsDetail(false)}>
                {
                    isDialogLoading ? (
                        <div className="flex justify-content-center h-full">
                            <ThreeDots height="50" width="50" radius="5" color="#00baac" ariaLabel="three-dots-loading" visible={isDialogLoading} />
                        </div>
                    ) :
                        (
                            <div>
                                <div className="dialog-table-container">
                                    <table className="dialog-table consumer-products-table" style={{ width: "100%", height: "100%" }} >
                                        <thead style={{ backgroundColor: "lightgrey" }} >
                                            <tr className="custom-table-tr">
                                                <th className="custom-th text-center">Sr No</th>
                                                <th className="custom-th text-center">Product Name</th>
                                                <th className="custom-th text-center">Specification</th>
                                                <th className="custom-th text-center">Quantity</th>
                                                <th className="custom-th text-center">Buyer PO No</th>
                                                <th className="custom-th text-center">Buyer PO Qty</th>
                                                <th className="custom-th text-center">Invoiced Qty</th>
                                            </tr>
                                        </thead >
                                        <tbody style={{ fontSize: "12px", borderCollapse: "collapse" }} >
                                            {
                                                displayedPOPunchItems?.map((item, index) => {
                                                    return (
                                                        <tr className="custom-tr" style={{ borderBottom: "1px solid #818181", borderCollapse: "collapse" }}>
                                                            <td className="custom-td text-center" >{index + 1}</td>
                                                            <td className="custom-td text-center" >{item.productName}</td>
                                                            <td className="custom-td text-center" >{item.productSpecification}</td>
                                                            <td className="custom-td text-center" ><b>{item.quantity}</b></td>
                                                            <td className="custom-td text-center" >{item.clientPONum}</td>
                                                            <td className="custom-td text-center" >{item.punchQty}</td>
                                                            <td className="custom-td text-center" >{item.invoicedQty}</td>
                                                        </tr>
                                                    )
                                                })
                                            }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        )
                }
            </Dialog>
        </div>

    )

}

export default ConsumerHistory